module.exports = __webpack_public_path__ + "img/our_values_sm.66a3fe6e.svg";